<template>
  <div
    :class="`wp-block-buttons is-layout-flex ${buttonType === 'secondary' && 'is-content-justification-center'}  wp-block-buttons-is-layout-flex`"
  >
    <div :class="`wp-block-button is-style-btn-${buttonType}`" @click="clickHandle">
      <span class="wp-block-button__link wp-element-button">
        <span class="text"> {{ buttonText }}</span>
        <span class="arrow">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 18 18"
          >
            <path
              fill="#000"
              d="M17.681 4.598a1.091 1.091 0 0 0-1.874.741l-.142 8.783L2.058.514A1.091 1.091 0 0 0 .515 2.057l13.607 13.608-8.782.141a1.091 1.091 0 0 0 .035 2.182l11.357-.184a1.09 1.09 0 0 0 1.073-1.073l.184-11.357c.005-.3-.114-.575-.308-.776Z"
            ></path>
          </svg>
        </span>
      </span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  clickHandle: {
    type: Function,
    default: () => {},
  },
  buttonText: {
    type: String,
    default: "",
  },
  buttonType: {
    type: String,
    default: 'secondary'
  }
});
</script>

<style lang="scss" scoped>
.is-style-btn-tertiary{
  .wp-element-button{
    .arrow {
        justify-content: end;
        padding: 0;
      }
  }
}
.wp-block-button.is-style-btn-tertiary .wp-element-button::after{
  bottom: 2px;
}
@media (min-width: 1440px) {
  .wp-block-button .wp-element-button {
    min-height: 78px;
  }
}
@media (max-width: 767px) {
  .wp-block-button .wp-element-button .arrow svg {
      height: 14px;
    }
}
</style>
